import React from 'react';
import './styles/site.scss';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { MsalTokenWrapper } from './components/MsalTokenWrapper';
import { Toaster } from 'react-hot-toast';

export const App: React.FunctionComponent = () => {
  return (
    <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
      <Toaster position="bottom-right" containerStyle={{ zIndex: 999999999 }} />
      <MsalTokenWrapper></MsalTokenWrapper>
    </MsalAuthenticationTemplate>
  );
};
